import React from 'react'
import PropTypes from 'prop-types'
import {Link} from 'react-router-dom'
import Moment from 'moment'
import './NewsBlock.sass'
import Col from "../Col"
import Container from "../Container"

const NewsBlock = ({newsContent}) => {
  if (!newsContent){
    return null
  }
  return (
    <section className="newsBlock-wrapper">
      <Container>
        <Col xs={6} sm={3} md={6} lg={6}>
          <h3 className="newsCaption">Новое на портале</h3>
        </Col>
        <Col xs={6} sm={9} md={18} lg={18}>
          <ul className="news-list">
            {newsContent.map((content) => {
              return (
                <li key={content.id} className="news-item">
                  <span className="news-item__date">{Moment(content.created_at).format('DD.MM.YYYY')}</span>
                  <Link to={`/posts/${content.id}`} className="news-item__link">
                    <h4 className="news-item__caption">{content.caption}</h4>
                    {content.description &&
                    <p className="news-item__text">{content.description}<span className="right_arrow" /></p>
                    }
                  </Link>
                </li>
              )
            })}
          </ul>
        </Col>
      </Container>
    </section>
  )
}

{/* eslint-disable */}
NewsBlock.propTypes = {
  newsContent: PropTypes.array.isRequired,
    id: PropTypes.number,
    created_at: PropTypes.string,
    caption: PropTypes.string,
    description: PropTypes.string
}
{/* eslint-disable */}

export default NewsBlock



// WEBPACK FOOTER //
// ./components/NewsBlock/index.jsx